// ----------------------------------------------------------------------

export default function Backdrop(theme) {
    return {
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    // Grey 800 in light; black in dark, where grey 800 is a
                    // surface colour and would barely darken the page.
                    backgroundColor: theme.palette.backdrop,
                },
                invisible: {
                    background: 'transparent',
                },
            },
        },
    };
}
